import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "../config/i18n";
import { useReleaseStatus } from "../hooks/useReleaseStatus";
export function WarmHeader({ activeSection, t }) {
    var _a;
    const albumReleaseDate = (_a = t.releases.album) === null || _a === void 0 ? void 0 : _a.releaseDate;
    const isAlbumReleased = useReleaseStatus(albumReleaseDate);
    const { lang, setLang } = useI18n();
    const releasedSingles = t.releases.singles.filter(e => e.releaseDate != undefined && useReleaseStatus(e.releaseDate));
    const headerMap = {
        biografia: { title: "BIO", bgColor: t.colors.light, text: t.colors.dark, line: t.colors.primary },
        releases: {
            title: isAlbumReleased ? "A ROOM FULL OF DOORS" : releasedSingles.length > 0 ? (lang == "it" ? "ASCOLTA" : "STREAM") : (lang == "it" ? "IN ARRIVO" : "COMING SOON"),
            bgColor: t.colors.accent, text: t.colors.dark, line: t.colors.secondary
        },
        events: { title: (lang == "it" ? "EVENTI" : "EVENTS"), bgColor: t.colors.light, text: t.colors.dark, line: t.colors.primary },
        contact: { title: "BAND", bgColor: t.colors.secondary, text: t.colors.light, line: t.colors.primary },
    };
    const state = activeSection === "biografia" ? headerMap.biografia
        : activeSection === "releases" ? headerMap.releases
            : activeSection === "contact" ? headerMap.contact
                : activeSection === "events" ? headerMap.events
                    : null;
    return (_jsx("div", { className: `fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${state ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"}`, children: state && (_jsx("div", { className: "mx-4 my-2 px-6 py-4 shadow-lg pointer-events-none transition-all duration-300", style: {
                backgroundColor: `${state.bgColor}F0`,
                border: `1px solid ${t.colors.primary}30`,
            }, children: _jsxs("div", { className: "text-center max-w-4xl mx-auto", children: [_jsx("h2", { className: "text-lg md:text-xl uppercase font-light tracking-[0.2em] transition-all duration-300", style: { color: state.text }, children: state.title }), _jsx("div", { className: "w-12 h-px mx-auto mt-2 transition-all duration-300 rounded-full", style: { backgroundColor: state.line } })] }) })) }));
}
